module.exports = __webpack_public_path__ + "assets/webgl/FloorPattern.jpg.3ca4a127.webp";